import { HTMLAttributes } from 'react'
import {
  DisplayProps,
  FlexboxProps,
  LayoutProps,
  PositionProps,
  SpaceProps,
  TypographyProps,
} from 'styled-system'

import { TestIdProps } from 'designSystem/types/propTypes'

import INTERNALxSpan from 'designSystem/components/internal/elements/INTERNALxSpan'
import { COLOR } from 'designSystem/foundations/constants/color'
import { FONT_SIZE } from 'designSystem/foundations/constants/fontSize'
import { FONT_WEIGHT } from 'designSystem/foundations/constants/fontWeight'
import { SIZE } from 'designSystem/foundations/constants/size'

type INTERNAL_TagSize = 'sm' | 'md' | 'lg'
type INTERNAL_TagVariant = 'alert' | 'info' | 'neutral' | 'success' | 'warning'

type BaseProps = HTMLAttributes<HTMLSpanElement> &
  DisplayProps &
  FlexboxProps &
  LayoutProps &
  PositionProps &
  SpaceProps &
  TestIdProps &
  TypographyProps

type Props = BaseProps & {
  size?: INTERNAL_TagSize
  showBorder?: boolean
  variant?: INTERNAL_TagVariant
}

export default function INTERNALxTag({
  showBorder = true,
  size = 'md',
  testId,
  variant = 'neutral',
  ...props
}: Props) {
  let variantStyles = INTERNAL_TAG_VARIANT[variant]
  let borderStyle = `1px solid ${variantStyles.borderColor}`

  if (!showBorder) borderStyle = 'none'

  return (
    <INTERNALxSpan
      {...props}
      alignItems="center"
      backgroundColor={variantStyles.backgroundColor}
      border={borderStyle}
      borderRadius={SIZE.s4}
      color={variantStyles.color}
      display="inline-flex"
      fontSize={INTERNAL_TAG_FONT_SIZE[size]}
      fontWeight={FONT_WEIGHT.semibold}
      testId={testId}
    />
  )
}

const INTERNAL_TAG_VARIANT = {
  alert: {
    backgroundColor: COLOR.alert100,
    borderColor: COLOR.alert400,
    color: COLOR.textAlert,
  },
  info: {
    backgroundColor: COLOR.info100,
    borderColor: COLOR.info400,
    color: COLOR.textLink,
  },
  neutral: {
    backgroundColor: COLOR.neutral200,
    borderColor: COLOR.neutral600,
    color: COLOR.textSecondary,
  },
  success: {
    backgroundColor: COLOR.success100,
    borderColor: COLOR.success400,
    color: COLOR.textSuccess,
  },
  warning: {
    backgroundColor: COLOR.warning100,
    borderColor: COLOR.warning400,
    color: COLOR.textWarning,
  },
}

const INTERNAL_TAG_FONT_SIZE: { [key: string]: string } = {
  sm: FONT_SIZE.fs12,
  md: FONT_SIZE.fs14,
  lg: FONT_SIZE.fs16,
}
